<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{pageData.MenuName}}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>系統類別</td>
                  <td colspan="3">
                    <select style="min-width: 300px" v-model="form.DirType">
                      <option
                        v-for="(item, index) in dropDownList.DirType"
                        :value="item.mcode"
                        :key="index"
                      >
                        {{ item.mvalue }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>系統功能目錄</td>
                  <td colspan="3">
                    <select
                      style="min-width: 300px"
                      v-model="form.DirdirectoryType"
                    >
                      <option
                        v-for="(item, index) in dropDownList.DirdirectoryType"
                        :value="item.dirCode"
                        :key="index"
                      >
                        {{ item.dirName }}
                      </option>
                    </select>
                    -
                    <select
                      style="min-width: 300px"
                      v-model="form.DirLayerType"
                    >
                      <option
                        v-for="(item, index) in dropDownList.DirLayerType"
                        :value="item.layerCode"
                        :key="index"
                      >
                        {{ item.layerName }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>程式類別</td>
                  <td>
                    <select style="min-width: 300px" v-model="form.PrgType">
                      <option
                        v-for="(item, index) in dropDownList.PrgType"
                        :value="item.mcode"
                        :key="index"
                      >
                        {{ item.mvalue }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>程式代碼</td>
                  <td>
                    <input size="40" type="text" v-model="form.PrgCode" />
                  </td>
                </tr>
                <tr>
                  <td>程式名稱</td>
                  <td colspan="3">
                    <input
                      type="text"
                      size="40"
                      maxlength="40"
                      v-model="form.PrgName"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="doQuery()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="新增"
                          @click="btnModalAdd('', 'I')"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnModalClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th colspan="2">操作</th>
                    <th>系統類別</th>
                    <th>系統功能目錄</th>
                    <th>程式名稱</th>
                    <th>程式類別</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="編"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnModalAdd(data, 'U')"
                      />
                    </td>
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="刪"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnModalDelete(data)"
                      />
                    </td>
                    <td>{{ data.dirtype }}</td>
                    <td>{{ data.diR_LAYER_NAME }}</td>
                    <td>{{ data.prgname }}</td>
                    <td>{{ data.prgtype }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <AddModal
      v-model="addModal.show"
      :title="addModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tr>
              <td>程式代碼</td>
              <td><input type="text" v-model="addModal.form.PrgCode" /></td>
            </tr>
            <tr>
              <td>程式名稱</td>
              <td>
                <input
                  type="text"
                  size="40"
                  maxlength="40"
                  v-model="addModal.form.PrgName"
                />
              </td>
            </tr>
            <tr>
              <td>程式類別</td>
              <td>
                <p>
                  <select
                    style="min-width: 300px"
                    v-model="addModal.form.PrgType"
                  >
                    <option
                      v-for="(item, index) in dropDownList.PrgType"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td>系統目錄階層</td>
              <td>
                <p>
                  <select
                    style="min-width: 300px"
                    v-model="addModal.form.DirType"
                  >
                    <option
                      v-for="(item, index) in dropDownList.DirType"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                </p>
                <p>
                  <select
                    style="min-width: 300px"
                    v-model="addModal.form.DirdirectoryType"
                  >
                    <option
                      v-for="(item, index) in dropDownList.DirdirectoryType"
                      :value="item.dirCode"
                      :key="index"
                    >
                      {{ item.dirName }}
                    </option>
                  </select>
                  -
                  <select
                    style="min-width: 300px"
                    v-model="addModal.form.DirLayerType"
                  >
                    <option
                      v-for="(item, index) in dropDownList.DirLayerType"
                      :value="item.pkno"
                      :key="index"
                    >
                      {{ item.layerName }}
                    </option>
                  </select>
                  <input
                    type="submit"
                    class="btn"
                    value="加入"
                    @click="btnAddModalAddTemp()"
                  />
                  <br />
                </p>
                <div class="table_scroll2">
                  <table width="1060" class="itable">
                    <tbody>
                      <tr
                        v-for="(data, index) in addModal.form.dirPknos"
                        :key="index"
                      >
                        <td width="1%" align="center">
                          <input
                            type="button"
                            class="btn"
                            value="刪"
                            data-toggle="modal"
                            data-target=".bs-example-modal-lg"
                            @click="btnAddModalRemoveTemp(data)"
                          />
                        </td>
                        <td>{{ data.text }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="f_center">
                <label for="checkbox"
                  ><span>
                    <input
                      type="submit"
                      class="btn"
                      value="存檔"
                      @click="btnAddModalSave()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      v-show="addModal.form.Type == 'I'"
                      @click="btnAddModalClear()"
                    /> </span
                ></label>
              </td>
            </tr>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AddModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex,getMenu , logOut} from "@/config/util.js";
import {
  S202_GetDirTypeOption,
  S202_GetDirdirectoryOption,
  S202_GetDirLayerOption,
  S202_GetPrgTypeOption,
  S202_QueryProgram,
  S202_EditProgram,
  S202_AddSaveProgram,
  S202_EditSaveProgram,
  S202_RemoveProgram,
} from "@/service/api.js";
export default {
  name: "S202",
  data: function () {
    return {
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S202",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      grid: [],
      addModal: {
        show: false,
        title: "S202系統程式維護-編輯",
        form: {
          Type: "",
          Pkno: "",
          DirType: "",
          DirLayerType: "",
          DirdirectoryType: "",
          PrgType: "",
          PrgCode: "",
          PrgName: "",
          dirPknos: [],
        },
        grid: [],
      },
      form: {
        DirType: "",
        DirdirectoryType: "",
        DirLayerType: "",
        PrgType: "",
        PrgCode: "",
        PrgName: "",
      },
      dropDownList: {
        DirType: [],
        DirLayerType: [],
        DirdirectoryType: [],
        PrgType: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    AddModal: VueModal,
  },
  methods: {
    getSearchDirtype: function () {
      const self = this;
      S202_GetDirTypeOption({ ServiceUnit: self.pageData.ServiceUnit }).then(
        (rData) => {
          self.dropDownList.DirType = rData.returnObject;
        }
      );
    },
    getSearchDirdirectorytype: function () {
      const self = this;
      S202_GetDirdirectoryOption({
        ServiceUnit: self.pageData.ServiceUnit,
      }).then((rData) => {
        self.dropDownList.DirdirectoryType = rData.returnObject;
      });
    },
    getSearchDirLayertype: function (data) {
      const self = this;
      S202_GetDirLayerOption({ ServiceUnit: self.pageData.ServiceUnit }).then(
        (rData) => {
          self.dropDownList.DirLayerType = rData.returnObject.filter(
            (x) => x.dirCode == data
          );
        }
      );
    },
    getSearchPrgtype: function () {
      const self = this;
      S202_GetPrgTypeOption().then((rData) => {
        self.dropDownList.PrgType = rData.returnObject;
      });
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        DirType: self.form.DirType,
        DirCode: self.form.DirdirectoryType,
        LayerCode: self.form.DirLayerType,
        PrgType: self.form.PrgType,
        PrgCode: self.form.PrgCode,
        PrgName: self.form.PrgName,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S202_QueryProgram(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //第一頁重填
    btnModalClear: function () {
      const self = this;
      self.form.DirType = "";
      self.form.DirLayerType = "";
      self.form.DirdirectoryType = "";
      self.form.PrgType = "";
      self.form.PrgCode = "";
      self.form.PrgName = "";
    },
    btnModalAdd: function (data, type) {
      const self = this;
      self.btnAddModalClear();
      self.addModal.form.Type = type;

      if (type == "U") {
        const self = this;
        self.addModal.form.Pkno = data.pkno;
        let postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          Pkno: data.pkno,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "編",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S202_EditProgram(postData).then((rData) => {
          self.addModal.grid = rData.returnObject;
          self.addModal.form.PrgCode = self.addModal.grid.prgCode;
          self.addModal.form.PrgName = self.addModal.grid.prgName;
          self.addModal.form.PrgType = self.addModal.grid.prgType;
          self.addModal.form.dirPknos = self.addModal.grid.dirPknos;
        });
      }
      self.addModal.show = true;
    },
    btnModalDelete: function (data) {
      const self = this;
      var msg = [];
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        PrgCode: data.prgcode,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S202_RemoveProgram(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push("刪除成功");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.form.Selected = [];
            self.addModal.show = false;
            self.doQuery();
            //self.reload();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          msg.push("刪除失敗");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //防呆
    Modalvalidation: function () {
      const self = this;
      const msg = [];
      if (!self.addModal.form.PrgType) msg.push("請選擇程式類別");
      if (self.addModal.form.PrgCode.trim() == "") msg.push("請填寫程式代碼");
      if (self.addModal.form.PrgName.trim() == "") msg.push("請填寫程式名稱");
      if (!self.addModal.form.dirPknos.map((x) => x.dirPkno).length)
        msg.push("請填寫系統目錄階層後加入");
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = msg;
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
      };
      return !msg.length;
    },
    btnAddModalSave: function () {
      const self = this;
      if (!self.Modalvalidation()) return;
      var msg = [];
      if (self.addModal.form.Type == "I") {
        let postData = {
          SysType: "1",
          ServiceUnit: self.pageData.ServiceUnit,
          PrgType: self.addModal.form.PrgType,
          PrgCode: self.addModal.form.PrgCode,
          PrgName: self.addModal.form.PrgName,
          DirPknos: self.addModal.form.dirPknos.map((x) => x.dirPkno),
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁新增",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        Object.keys(postData).map(
          (k) =>
            (postData[k] =
              typeof postData[k] == "string" ? postData[k].trim() : postData[k])
        );
        S202_AddSaveProgram(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            msg.push("新增成功");
            self.Alert.txt = msg;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.form.Selected = [];
              self.addModal.show = false;
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            msg.push("新增失敗");
            self.Alert.txt = msg;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }

      if (self.addModal.form.Type == "U") {
        let postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          Pkno: self.addModal.form.Pkno,
          SysType: "1",
          PrgType: self.addModal.form.PrgType,
          PrgCode: self.addModal.form.PrgCode,
          PrgName: self.addModal.form.PrgName,
          DirPknos: self.addModal.form.dirPknos.map((x) => x.dirPkno),
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁存檔",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        Object.keys(postData).map(
          (k) =>
            (postData[k] =
              typeof postData[k] == "string" ? postData[k].trim() : postData[k])
        );
        S202_EditSaveProgram(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            msg.push("更新成功");
            self.Alert.txt = msg;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.form.Selected = [];
              self.addModal.show = false;
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            msg.push("更新失敗");
            self.Alert.txt = msg;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
    btnAddModalClear: function () {
      const self = this;
      self.addModal.form.DirType = "";
      self.addModal.form.DirLayerType = "";
      self.addModal.form.DirdirectoryType = "";
      self.addModal.form.PrgType = "";
      self.addModal.form.PrgCode = "";
      self.addModal.form.PrgName = "";
      self.addModal.form.dirPknos = [];
    },
    btnAddModalAddTemp: function () {
      const self = this;
      var msg = [];
      if (self.addModal.form.DirLayerType == "") {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        msg.push("目錄階層不得為空");
        self.Alert.txt = msg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
      } else {
        if (
          self.addModal.form.dirPknos.filter(
            (x) => x.dirPkno == self.addModal.form.DirLayerType
          ).length > 0
        ) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          msg.push("目錄階層不得重複");
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
          };
          return;
        }
        var text1 = self.dropDownList.DirType.filter(
          (x) => x.mcode == self.addModal.form.DirType
        )[0].mvalue;
        var text2 = self.dropDownList.DirdirectoryType.filter(
          (x) => x.dirCode == self.addModal.form.DirdirectoryType
        )[0].dirName;
        var text3 = self.dropDownList.DirLayerType.filter(
          (x) => x.pkno == self.addModal.form.DirLayerType
        )[0].layerName;
        let pushData = {
          dirPkno: self.addModal.form.DirLayerType,
          text: text1 + "/" + text2 + "/" + text3,
        };
        self.addModal.form.dirPknos.push(pushData);
      }
    },
    btnAddModalRemoveTemp: function (data) {
      const self = this;
      self.addModal.form.dirPknos = self.addModal.form.dirPknos.filter(
        (x) => x.dirPkno != data.dirPkno
      );
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if(Menu){
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.getSearchDirtype();
    //self.getSearchDirLayertype();
    self.getSearchDirdirectorytype();
    self.getSearchPrgtype();
    self.doQuery();
  },
  watch: {
    "form.DirdirectoryType": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.form.DirLayerType = "";
        self.dropDownList.DirLayerType = [];
      } else {
        self.getSearchDirLayertype(newValue);
      }
    },
    "addModal.form.DirdirectoryType": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.form.DirLayerType = "";
        self.dropDownList.DirLayerType = [];
      } else {
        self.getSearchDirLayertype(newValue);
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
